import { send } from "../../send";

/**
 * send(1.method, 2.url, 3.data, 4.expend) 1.请求类型 2.请求地址 3.请求参数 4.拓展(如统一的uuid)
 * 报表模块
 */

export const Waste = {
    /**
     * 危废库存相关
     * @param {*} parmas 参数
     * @param {*} expend 拓展(uuid)
     */
    getWasteInfoList(parmas, expend) { // 查询列表
        return send("GET", "/api/company/waste/info/find", parmas, expend);
    },
    getWasteStatistics(parmas, expend) {
        return send("GET", "/api/company/waste/statistics", parmas, expend);
    },
    getWasteStatistics2(parmas, expend) {
        return send("GET", "/api/company/waste/statistics2", parmas, expend);
    },
    getWasteStatistics3(parmas, expend) {
        return send("GET", "/api/company/waste/statistics3", parmas, expend);
    },
    //库存
    inventory(parmas, expend) {
        return send("GET", "/api/company/waste/inventory", parmas, expend);
    },
    /**
     * 一般固废台账相关
     * @param {*} parmas 参数
     * @param {*} expend 拓展(uuid)
     */
    getWasteSolidInfoList(parmas, expend) { // 查询列表
        return send("GET", "/api/company/wasteSolid/find", parmas, expend);
    },
    postWasteSolidInfoAdd(parmas, expend) { // 添加
        return send("POST", "/api/company/wasteSolid/create", parmas, expend);
    },
    postWasteSolidInfoEdit(parmas, expend) { // 更新
        return send("POST", "/api/company/wasteSolid/modify", parmas, expend);
    },
    getWasteSolidInfoDel(parmas, expend) { // 删除
        return send("GET", "/api/company/wasteSolid/del/" + parmas.content.id, {}, expend);
    },
    getWasteSolidStatistics(parmas, expend) {
        return send("GET", "/api/company/wasteSolid/statistics", parmas, expend);
    },
    getWasteSolidStatistics2(parmas, expend) {
        return send("GET", "/api/company/wasteSolid/statistics2", parmas, expend);
    },
    getWasteSolidStatistics3(parmas, expend) {
        return send("GET", "/api/company/wasteSolid/statistics3", parmas, expend);
    },
    //库存
    inventorySolid(parmas, expend) {
        return send("GET", "/api/company/wasteSolid/inventory", parmas, expend);
    },

    /**
     * 危废企业编辑
     * @param {*} parmas 参数
     * @param {*} expend 拓展(uuid)
     */
    getWasteCompanyList(parmas, expend) { // 查询列表
        return send("GET", "/api/company/waste/company/find", parmas, expend);
    },
    postWasteCompanyAdd(parmas, expend) { // 添加
        return send("POST", "/api/company/waste/company/create", parmas, expend);
    },
    postWasteCompanyEdit(parmas, expend) { // 更新
        return send("POST", "/api/company/waste/company/modify", parmas, expend);
    },
    getWasteCompanyDel(parmas, expend) { // 删除
        return send("GET", "/api/company/waste/company/del/" + parmas.content.id, {}, expend);
    },
    // getWasteCompanyGet(parmas, expend) { // 单个
    //     return send("GET", "/api/company/waste/company/get/" + parmas.id, {}, expend)
    // },

    /**
     * 危废类型编辑
     * @param {*} parmas 参数
     * @param {*} expend 拓展(uuid)
     */
    getWasteTypeManageList(parmas, expend) { // 查询列表
        return send("GET", "/api/company/waste/type/find", parmas, expend);
    },
    postWasteTypeManageAdd(parmas, expend) { // 添加
        return send("POST", "/api/company/waste/type/create", parmas, expend);
    },
    postWasteTypeManageEdit(parmas, expend) { // 更新
        return send("POST", "/api/company/waste/type/modify", parmas, expend);
    },
    getWasteTypeManageDel(parmas, expend) { // 删除
        return send("GET", "/api/company/waste/type/del/" + parmas.content.id, {}, expend);
    },
    getWasteTypeAll(parmas, expend) {
        return send("GET", "/api/company/waste/type/all", parmas, expend);
    },

    /**
     * 一般固废类型编辑
     * @param {*} parmas 参数
     * @param {*} expend 拓展(uuid)
     */
    getWasteSolidTypeManageList(parmas, expend) { // 查询列表
        return send("GET", "/api/company/wasteSolid/type/find", parmas, expend);
    },
    postWasteSolidTypeManageAdd(parmas, expend) { // 添加
        return send("POST", "/api/company/wasteSolid/type/create", parmas, expend);
    },
    postWasteSolidTypeManageEdit(parmas, expend) { // 更新
        return send("POST", "/api/company/wasteSolid/type/modify", parmas, expend);
    },
    getWasteSolidTypeManageDel(parmas, expend) { // 删除
        return send("GET", "/api/company/wasteSolid/type/del/" + parmas.content.id, {}, expend);
    },
    getWasteSolidTypeAll(parmas, expend) {
        return send("GET", "/api/company/wasteSolid/type/all", parmas, expend);
    },

    /**
     * 危废入库申请
     * @param {*} parmas 参数
     * @param {*} expend 拓展(uuid)
     */
    getWasteRequestUserRole(parmas, expend) {
        return send("POST", "/api/company/waste/request/userRole", parmas, expend);
    },
    getWasteRequestList(parmas, expend) { // 查询列表
        return send("GET", "/api/company/waste/request/find", parmas, expend);
    },
    postWasteRequestAdd(parmas, expend) { // 添加
        return send("POST", "/api/company/waste/request/create", parmas, expend);
    },
    postWasteRequestEdit(parmas, expend) { // 更新
        return send("POST", "/api/company/waste/request/modify", parmas, expend);
    },
    postWasteRequestApprove(parmas, expend) { // 审批
        return send("POST", "/api/company/waste/request/approve", parmas, expend);
    },
    postWasteRequestRecipient(parmas, expend) { // 接收
        return send("POST", "/api/company/waste/request/recipient", parmas, expend);
    },
    getWasteRequestDel(parmas, expend) { // 删除
        return send("GET", "/api/company/waste/request/del/" + parmas.content.id, {}, expend);
    },
    /**
     * 危废提醒
     * @param {*} parmas 参数
     * @param {*} expend 拓展(uuid)
     */
    getWasteReminderList(parmas, expend) { // 查询列表
        return send("GET", "/api/company/waste/reminder/find", parmas, expend);
    },
    /**
     * 固废核查
     * @param {*} parmas 参数
     * @param {*} expend 拓展(uuid)
     */
    getSolidWasteAuditList(parmas, expend) { // 查询列表
        return send("GET", "/api/company/waste/audit/find", parmas, expend);
    },
    postSolidWasteAuditAdd(parmas, expend) { // 添加
        return send("POST", "/api/company/waste/audit/create", parmas, expend);
    },
    postSolidWasteAuditEdit(parmas, expend) { // 更新
        return send("POST", "/api/company/waste/audit/modify", parmas, expend);
    },
    getSolidWasteAuditDel(parmas, expend) { // 删除
        //console.log(parmas.content.id);
        return send("GET", "/api/company/waste/audit/del/" + parmas.content.id, {}, expend);
    },
    getFaceLogList(parmas, expend) { // 查询登录日志
        return send("GET", "/api/v1/find", parmas, expend);
    },
    getFaceUserEnum(parmas, expend) { // 查询登录过的所有用户信息
        return send("GET", "/api/v1/users", parmas, expend);
    }, 
}